import { api_POST } from "./_api.js";

const relatorio_api = {
    RelatorioGerenciamentoArrecadacao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Relatorios/RelatorioGerenciamentoArrecadacao", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    RelatorioDividaAtiva: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Relatorios/RelatorioDividaAtiva", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    MapaFiscalizacoes: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Relatorios/MapaFiscalizacoes", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    RankingFiscalizacoes: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Relatorios/RankingFiscalizacoes", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    RelatorioInfracoes: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Relatorios/RelatorioInfracoes", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default relatorio_api;
